import { apiFetch } from "../utils/apiFetch";
import { API_BASE_ADMIN } from "../config/vars";

export const fetchActiveNetworks = async () => {
    const response = await apiFetch(`${API_BASE_ADMIN}/networks/admin/active`);
    if (!response.ok) throw new Error("Не вдалося завантажити мережі");
    return response.json();
};

export const fetchNetworks = async () => {
    const response = await apiFetch(`${API_BASE_ADMIN}/networks/admin`);
    if (!response.ok) throw new Error("Не вдалося завантажити мережі");
    return response.json();
};

export const fetchNetworkFeatureCatalog = async () => {
    const response = await apiFetch(`${API_BASE_ADMIN}/networks/admin/feature-catalog`);
    if (!response.ok) throw new Error("Не вдалося завантажити каталог модулів");
    return response.json();
};

export const fetchNetworkStats = async () => {
    const response = await apiFetch(`${API_BASE_ADMIN}/networks/admin/stats`);
    if (!response.ok) throw new Error("Не вдалося завантажити статистику мереж");
    return response.json();
};

export const updateNetwork = async (id, data) => {
    const response = await apiFetch(`${API_BASE_ADMIN}/networks/admin/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || "Не вдалося оновити мережу");
    }
    return response.json();
};

export const addNetwork = async (data) => {
    const response = await apiFetch(`${API_BASE_ADMIN}/networks/admin`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || "Не вдалося додати мережу");
    }
    return response.json();
};
